import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(() => {
	const { blockContainerJsClass } = manifest;

	const blockContainerElements = document.querySelectorAll(`.${blockContainerJsClass}`);

	if (blockContainerElements.length) {
		[...blockContainerElements].forEach((autoscrollCarouselElement) => {
			import('./autoscroll-carousel').then(({ AutoscrollCarousel }) => {
				const autoscrollCarousel = new AutoscrollCarousel({
					autoscrollCarouselElement,
				});

				autoscrollCarousel.init();
			});

			import('./grid-adjust').then(({ GridAdjust }) => {
				const gridAdjust = new GridAdjust({
					originalGridElement: autoscrollCarouselElement.parentElement.parentElement.parentElement,
					gridElement: autoscrollCarouselElement,
					variableName: '--autoscroll-carousel-column-width',
				});

				gridAdjust.init();
			});
		});
	}
});
